import React from 'react';
import {Popup} from 'semantic-ui-react';
import styled from 'styled-components';

import * as S from './LabeledOption.styles';

interface LabeledOptionProps {
  label: string;
  option: React.ReactNode;
  helpText?: string;
  docUrl?: string;
  labelWidth?: string;
}

const DEFAULT_LABEL_WIDTH = '100px';

const StyledLabelOption = styled.div<{$labelWidth: string}>`
  align-items: center;
  display: flex;
  justify-content: flex-start;
  padding: 4px 0;

  & + .accordion.ui.advanced-options {
    padding-left: ${props => props.$labelWidth};
  }
`;
const StyledLabel = styled.label<{$labelWidth: string}>`
  display: block;
  font-weight: 600;
  width: ${props => props.$labelWidth};
  padding-right: 12px;
`;
const StyledOption = styled.div<{$labelWidth: string}>`
  flex-grow: 1;
  max-width: calc(100% - ${props => props.$labelWidth});

  input {
    background-color: white;
  }
  .number-input__container {
    margin-right: 0px;
  }

  .number-input__input {
    margin-right: 0px;
  }

  .smoothing-type-trigger {
    margin-left: 10px;
  }
`;

export const LabeledOptionBlock: React.FC<LabeledOptionProps> = props => {
  const labelWidth = props.labelWidth ?? DEFAULT_LABEL_WIDTH;

  const optionLabel = <S.OptionLabel>{props.label}</S.OptionLabel>;

  const popupLabel =
    props.helpText != null ? (
      <Popup
        inverted
        size="mini"
        trigger={optionLabel}
        content={props.helpText}
      />
    ) : (
      optionLabel
    );

  return (
    <StyledLabelOption
      $labelWidth={labelWidth}
      data-test={`styled-label-option-${props.label}`}>
      <StyledLabel $labelWidth={labelWidth} data-test="styled-label">
        {popupLabel}
      </StyledLabel>
      <StyledOption $labelWidth={labelWidth} data-test="styled-option">
        <S.Option>{props.option}</S.Option>
      </StyledOption>
    </StyledLabelOption>
  );
};

export default LabeledOptionBlock;
